import { EmailClientsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function ReportsEmailClientsRoute() {
  const { workspaceId } = Route.useParams();
  return <EmailClientsRoute segment="reports" workspaceId={workspaceId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/reports/email-clients')({
  component: ReportsEmailClientsRoute,
});
